import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Resets the scroll position to the top of the page whenever the `pathname` changes
 */
const ScrollAppToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};
// Exports
// -------
export { ScrollAppToTop };
